import { render, staticRenderFns } from "./password-policy.vue?vue&type=template&id=108a2d0d&scoped=true"
import script from "./password-policy.vue?vue&type=script&lang=js"
export * from "./password-policy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108a2d0d",
  null
  
)

export default component.exports